import { AppContext } from "next/app";

export const DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
export const PRODDOMAIN = "https://panel.organic-festa.com";
export const PRODFORNTDOMAIN = "https://exhibitor.organic-festa.com";


